export const BANK_ACCOUNT_ID = '110604496666';
export const BANK_BRANCH_NAME = 'Vietinbank - Chi nhánh 6';
export const BANK_ACCOUNT_NAME = 'CT CP CONG NGHE DOCCEN';
export const DOCCEN_CARE_GMAIL_PRE_COMPOSE_URL =
  'https://mail.google.com/mail/u/2/#inbox?compose=GTvVlcSDbhKwgVSDHdtSpNpPWXKfrDRrXWfJCcKvkLgnpVGfMHjcWqFmwfFQWzhNMfQdzLwChbhhL';
